import styled, {css} from 'styled-components';

import {InputFile} from 'components/ui-kit/FileInput';
import {border, breakpoint, colors, font} from 'theme';

export const ErrorList = styled.ul`
    margin: 5px 0;
    padding-left: 17px;
`;
export const ErrorItem = styled.li`
    color: ${colors.danger};
    font-size: 14px;
    line-height: 20px;
`;

export const Root = styled.div<{horizontal?: boolean; updatedDesign?: boolean}>`
    display: flex;

    flex-wrap: wrap;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    ${(p) =>
        p.horizontal &&
        css`
            flex-direction: row;
        `}
    ${(p) =>
        p.updatedDesign &&
        css`
            justify-content: flex-end;
        `}
`;

export const CustomFileInput = styled(InputFile)<{updatedDesign?: boolean}>`
    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        width: 100%;
        font-size: 14px;
    }

    ${(p) =>
        p.updatedDesign &&
        css`
            background-color: ${colors.brandPrimary};
            color: ${colors.white};
        `}
`;

export const CustomLink = styled.a<{updatedDesign?: boolean}>`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    margin-top: 4px;
    &:hover {
        text-decoration: underline;
    }

        ${(p) =>
            p.updatedDesign &&
            css`
                margin-top: 0;
                height: 44px;
                display: flex;
                border-radius: ${border.radius};
                box-sizing: border-box;
                justify-content: center;
                align-items: center;
                padding: 10px 16px;
                white-space: nowrap;
                background-color: ${colors.white};
                color: ${colors.brandPrimary};
                border: 1px solid ${colors.brandPrimary};

                font-family: ${font.family.primary};
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;

                &:hover {
                    text-decoration: none;
                }
            `}

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;

export const CustomLinkAction = styled.span`
    color: ${colors.brandPrimary};
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
    }

    @media (max-width: ${breakpoint.phone}) {
        min-width: 200px;
        flex: 1;
        text-align: center;
    }
`;
